<template>
    <div class="deviceList">
        <div class="clearfix">
            <van-nav-bar
                class="restclass"
                title="首 页">
                <van-cell slot="right" style="background:none">
                    <van-button round
                        style="padding:10px; font-size:0.3rem;" @click="onLogout">退出</van-button>
                </van-cell>
            </van-nav-bar>
        </div>

        <div class="clientList">
            <grid clickable :column-num="4" class="menu">
                <grid-item v-if="$_has('entrance:entrance:view')" text="路由跳转" to="/entranceVehicle">
                    <icon name="column" color="#1989fa" size="30" />
                    <span class="nav-span">入场检查</span>
                </grid-item>
                <grid-item v-if="$_has('maintain:workorder:view')" text="路由跳转" to="/dispatching">
                    <icon name="graphic" color="#07c160" size="30" />
                    <span class="nav-span">派工调度</span>
                </grid-item>
                <grid-item v-if="$_has('maintain:workorderoverview:view')" text="路由跳转" to="/workorderlist">
                    <icon name="apps-o" color="#f00" size="30" />
                    <span class="nav-span">派工单总览</span>
                </grid-item>
                <grid-item v-if="$_has('maintain:workordersearch:view')" text="路由跳转" to="/workorderlistsearch">
                    <icon name="column" color="#f00" size="30" />
                    <span class="nav-span">派工单查看</span>
                </grid-item>
                <grid-item v-if="$_has('maintain:qualitycheck:view')" text="路由跳转" to="/qualityCheckList">
                    <icon name="idcard" color="#f58220" size="30" />
                    <span class="nav-span">质检管理</span>
                </grid-item>
                <grid-item v-if="$_has('maintain:statement:view')" text="路由跳转" to="/StatementList">
                    <icon name="coupon" color="#1989fa" size="30" />
                    <span class="nav-span">结算单管理</span>
                </grid-item>
                <grid-item v-if="$_has('maintain:maintenancelist:view')" text="路由跳转" to="/toMaintainList">
                    <icon name="graphic" color="#07c160" size="30" />
                    <span class="nav-span">待保养</span>
                </grid-item>
                <grid-item v-if="$_has('maintain:faultlist:view')" text="路由跳转" to="/faultrepaired">
                    <icon name="notes-o" color="#f00" size="30" />
                    <span class="nav-span">待修故障列表</span>
                </grid-item>
                <grid-item v-if="$_has('maintain:maintainitemlist:view')" text="路由跳转" to="/partsrepair">
                    <icon name="coupon" color="#1989fa" size="30" />
                    <span class="nav-span">维修项目</span>
                </grid-item>
                <!-- <grid-item text="路由跳转">
                    <icon name="column" color="#1989fa" size="30" />
                    <span class="nav-span">设备绑定</span>
                </grid-item> -->
                <grid-item v-if="$_has('maintain:workorderoverview:view')" text="路由跳转" @click="scan('车辆状态查看')">
                    <icon name="scan" color="#07c160" size="30" />
                    <span class="nav-span">车辆状态查看</span>
                </grid-item>
                <grid-item v-if="$_has('entrance:entrance:out')" text="路由跳转" to="/departure">
                    <icon name="search" color="#1989fa" size="30" />
                    <span class="nav-span">离场</span>
                </grid-item>
                <!-- <grid-item v-if="$_has('base:parts:view')" text="路由跳转" to="/entranceExit">
                    <icon name="search" color="#1989fa" size="30" />
                    <span class="nav-span">入场离场</span>
                </grid-item> -->
                
                <!-- <grid-item text="路由跳转">
                    <icon name="coupon" color="#1989fa" size="30" />
                    <span class="nav-span">质检管理</span>
                </grid-item> -->
                <!-- <grid-item text="路由跳转" >
                    <icon name="column" color="#1989fa" size="30" />
                    <span class="nav-span">出入场</span>
                </grid-item> -->

            </grid>
            <row v-if="$_has('board:entryequipment:view')" class="search">
                <van-col span="18"><search v-model="value" placeholder="请输入搜索关键词" class="search" /></van-col>
                <van-col span="2"><button @click="queryreocrdbycondition">查询</button></van-col>
                <van-col span="2" style="float:right; margin:7px 0px 0 15px !important;">
                    <van-icon name="scan" size="30" round title="扫一扫"
                        @click="carScan('入场检查')" />
                </van-col>
                <!-- @click="MoreList(1)" -->
            </row>
            <div v-if="$_has('entrance:entrance:view')" class="clientList">
                <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
                    <List
                        v-model="isUpLoading"
                        :finished="upFinished"
                        :immediate-check="false"
                        :offset="10"
                        finished-text="已加载全部"
                        @load="onLoadList">
                        <div
                            v-for="(item,index) in list"
                            :key="index"
                            class="list clearfix">
                            <div class="clearfix">
                                <row>
                                    <van-col span="1">{{ index+1 }}</van-col>
                                    <van-col span="20">
                                        <p>
                                            <span class="info-span">{{ item.vehicleCode }}</span>
                                            <span class="info-span">{{ item.barCode }}</span>
                                            <span class="info-span">{{ item.driver }}</span>
                                            <span class="info-span-red">{{ item.enumVehicleStatusName }}</span>
                                        </p>
                                        <p style="line-height:20px;"><icon name="clock-o" color="#1989fa" />入场：{{ item.entryTime }}</p>
                                    </van-col>
                                    <van-col v-if="$_has('entrance:entrance:assign')" span="3"><van-button type="primary" round @click="onClientDispatch(item)">派工</van-button></van-col>
                                </row>
                            </div>
                        </div>
                        <van-dialog
                            v-model="isShow"
                            title="请选择"
                            show-cancel-button
                            @confirm="submit">
                            <van-field
                                v-model="submititem.maintenTypeName"
                                :readonly="projectreadonly"
                                :show-error="true"
                                :required="true"
                                :disabled="true"
                                name="maintenTypeName"
                                :rules="[ { required: true, message: '必填' } ]"
                                label="维修类型"
                                @click="!projectreadonly ? showmaintainItemse = true : showmaintainItemse==false" />
                        </van-dialog>
                    </List>
                    <van-popup
                        v-model="showmaintainItemse"
                        :style="{ height: '35%' }"
                        position="bottom">
                        <van-picker
                            item-height="1.173rem"
                            show-toolbar
                            :columns="maintenTypes"
                            @cancel="showmaintainItemse = false"
                            @confirm="maintenTypeNamese" />
                    </van-popup>
                </van-pull-refresh>
                <p
                    v-if="list.length === 0"
                    class="noList">暂无数据</p>
            </div>
        </div>
        <bottom />
    </div>
</template>

<script>
// import { getDeviceList } from '@/api/index'

// eslint-disable-next-line no-unused-vars
var moment = require('moment')
import { Icon, List, Dialog, Button, Grid, GridItem, Search, Col, Row, Sticky, Toast, Notify } from 'vant'
import bottom from '@/components/bottom'
import { getDictionarySelect, getOdd } from '@/api/basics'
import { getrecordlist } from '@/api/maintain'
import { submitRecords } from '@/api/maintain'
export default {
    name: 'Index',
    components: {
    // eslint-disable-next-line vue/no-unused-components
        Icon, List, [Button.name]: Button, Grid, GridItem, Search, [Col.name]: Col, Row, Sticky,
        bottom
    },
    data() {
        return {
            isDownLoading: false, // 下拉刷新
            isUpLoading: false, // 上拉加载
            upFinished: false, // 上拉加载完毕
            totalCount: 0,
            isShow: false,
            submititem: {

            },
            sheetNos: '',
            showmaintainItemse: false,
            projectreadonly: false,
            maintenTypes: [],
            parameter: {
                enumVehicleStatus: '1',
                searchKey: '', //
                pageIndex: 1, // 当前页
                pageSize: 10 // 每页多少条
            },
            list: [],
            value: '',
            type: ''
        }
    },
    mounted() {
        this.queryrecord()
        window['scanit'] = data => {
            this.scanit(data)
        }
        // this.$nextTick(() => {
        //     console.log(document.getElementById('myCanvas'))
        //     this.ctx = document.getElementById('myCanvas').getContext('2d')
        //     this.c = document.getElementById('myCanvas')
        //     this.InitThis()
        // })
        getDictionarySelect({ Code: 'Maintain:MaintenceType' }).then(res => {
            if (res.isSuccess) {
                console.log(res.data)
                this.maintenTypes = res.data
                this.maintenTypes.forEach(item => {
                    item.text = item.name
                })
            }
        })
    },
    // examineTime: new Date(),
    // examinator: this.$store.state.user.userInfo.nickName,
    methods: {
    async submit() {
            if (this.submititem.maintenTypeName == '') {
                Toast('请选择维修类型')
                return false
            }
           await this.getOdd()
            this.submititem.examinator = this.$store.state.user.userInfo.nickName
            var date = new Date();
            var year = date.getFullYear(); //获取当前年份
            var month = date.getMonth() + 1; //获取当前月份
            var dat = date.getDate(); //获取当前日
            var hour = date.getHours(); //获取小时
            var minutes = date.getMinutes(); //获取分钟
            var second = date.getSeconds(); //获取秒
            const Time = year + '-' + month + '-' + dat + ' ' + hour + ':'+ minutes + ':'+ second;
            this.submititem.examineTime = Time
            this.submititem.examinator = this.$store.state.user.userInfo.nickName
            submitRecords(this.submititem).then((res) => {
                if (res.isSuccess) {
                    //Notify({ type: 'success', message: '提交成功' })
                    Toast.success('提交成功')
                    // return
                    // if (value) {
                    //     if (this.$_has('maintain:workorder:view')) {
                    //         this.$router.push({
                    //             path: '/dispatchList',
                    //             query: {
                    //                 type: '入场处理',
                    //                 id: this.submititem.id
                    //             }
                    //         })
                    //     } else {
                    //         this.$router.push({
                    //             path: '/404'
                    //         })
                    //     }
                    // } else {
                    //     this.$router.push({
                    //         path: '/entrancevehicle'
                    //     })
                    // }
                } else {
                    Toast(res.message)
                    return false
                }
            })
        },
        // 确认维修类型
        maintenTypeNamese(val) {
            console.log(val, 'jrr')
            this.maintenTypes.forEach(async res => {
                if (res.id == val.id) {
                    this.submititem.maintenTypeName = res.name
                    this.submititem.maintenTypeId = res.code
                    this.showmaintainItemse = false
                    this.submititem.factor = res.factor
                    this.submititem.code = res.code
                }
            })
        },
        getUserInfo(event) {
            console.log(event.detail)
        },

        onClose() {
            this.show = false
        },
        // 注销登录
        onLogout() {
            // this.$router.push({
            //     path: '/information'
            // })
            Dialog.setDefaultOptions({
                width: '6rem'
            })
            Dialog.confirm({
                message: '确认退出吗？'
            }).then(async() => {
                await this.$store.dispatch('user/logout')
                this.$router.push({ name: 'Login', params: { type: 'up' }})
                var u = navigator.userAgent
                if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // 安卓手机
                    window.test.loginOut()
                }
                // this.$router.push({
                //     path: '/login'
                // })
            })
        },
        getBack() {
            this.$router.back()
        },
        queryrecord(isreload = true) {
            getrecordlist(this.parameter).then((res) => {
                if (res.code == 200) {
                    this.totalCount = res.data.totalCount
                    var i = 0
                    for (i; i < res.data.pagerData.length; i++) {
                        res.data.pagerData[i].entryTime = this.parsetime(res.data.pagerData[i].entryTime)
                    }
                    if (isreload == true) {
                        this.list = res.data.pagerData
                    } else {
                        this.list = this.list.concat(res.data.pagerData)
                    }
                } else {
                    Toast(res.message)
                }
            })
                .finally(() => {
                    this.isDownLoading = false
                    this.isUpLoading = false
                })
        },
        queryreocrdbycondition() {
            this.list = []
            this.parameter.pageIndex = 1
            this.parameter.category = this.value1
            this.parameter.enumVehicleStatus = this.value2
            this.parameter.brand = this.value3
            this.parameter.searchKey = this.value
            this.upFinished = false
            this.queryrecord()
        },
        queryallreocrd() {
            this.list = []
            this.parameter.pageIndex = 1
            this.parameter.category = ''
            this.parameter.enumVehicleStatus = ''
            this.parameter.brand = ''
            this.parameter.searchKey = ''
            this.upFinished = false
            this.queryrecord()
        },
        onDownRefresh() {
            this.parameter.pageIndex = 1
            this.upFinished = false // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
            this.queryrecord() // 加载数据
        },
        onLoadList() {
            this.parameter.pageIndex++
            this.isDownLoading = false
            this.queryrecord(false) // 加载数据
            if (this.totalCount == this.list.length) {
                this.upFinished = true
            } else {
                this.upFinished = false
            }
        },
        parsetime(date1) {
            var date = new Date(date1)
            var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
            var currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
            var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
            var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            return date.getFullYear() + '-' + month + '-' + currentDate + ' ' + hours + ':' + minutes + ':' + seconds
        },
    PrefixInteger(num, length) {
      return (Array(length).join('0') + num).slice(-length);
    },
        // 生成单号
    async getOdd() {
        let tenantCode = null
        if (!this.$store.state.user.userInfo.tenantId) {
            tenantCode = '0000'
        }else{
            tenantCode = this.PrefixInteger(this.$store.state.user.userInfo.tenantId,4)
        }
            var sheetNo = `PG${tenantCode}${moment().format('YYYY')}${moment().format('MM')}${moment().format('DD')}`
        const res = await getOdd(sheetNo)
                    if (res.isSuccess) {
                        this.submititem.WorkOrderSheetNo = res.data.sheetNo
                        this.submititem.workOrderSheetNo = res.data.sheetNo
                        
                        console.log(res.data, '单号')
                    }
        },
        onClientDispatch(val) {
            this.submititem = val
            console.log(val)
            this.submititem.maintenTypeName = ''
            this.isShow = !this.isShow
        },
        scan(value) {
            this.type = value
            window.test.ToScan()
        },
        async scanit(val) {
            if (this.type == '车辆状态查看') {
                this.$router.push({
                    path: '/workorderlist',
                    query: { barCode: val, type: '车辆状态' }
                })
            } else if (this.type == '入场检查') {
                this.parameter.pageIndex = 1
                this.parameter.barCode = val
                getrecordlist(this.parameter).then((res) => {
                    if (res.code == 200) {
                        this.totalCount = res.data.totalCount
                        var i = 0
                        for (i; i < res.data.pagerData.length; i++) {
                            res.data.pagerData[i].entryTime = this.parsetime(res.data.pagerData[i].entryTime)
                        }
                        this.list = res.data.pagerData
                    } else {
                        Toast(res.message)
                    }
                })
            }
        },
        carScan(value) {
            this.type = value
            window.test.ToScan()
        }
    }
}
</script>

<style lang='scss' scoped>
.deviceList{
  width: 100%;
  .logout{
    margin-top: -20px;
    color:#ffffff;
    font-size:0.35rem;
    // color: #1989fa;
  }
  .clientList{
    margin-bottom: 120px;
    padding: 0px  20px 0px 20px;
    h2{
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .search{
        margin:10px 0;
    //   input{
    //     width: 75%;
    //     height: 70px;
    //     color: #9B9B9B;
    //     font-size: 100px;
    //     line-height: 70px;
    //     padding-bottom: 15px;
    //     border-bottom: 1px solid #DCDCDC;
    //   }
      button{
        width: 100px;
        height: 60px;
        background-color: #1989fa;
        color: #ffffff;
        margin:15px 10px;
        border-radius: 10px;
      }
    }
    .list{
      padding: 20px 0;
      border-bottom: 1px solid #ccc;
      h3{
        font-size: 38px;
        font-weight: 700;
      }
      .msg{
        padding: 20px 0;
        font-size: 18px;
        .phone{
          margin-left: 10%;
          color: #3498db;
        }
      }
      p{
        color: #999;
        font-size: 20px;
        padding: 5px 0;
      }
    }
  }

}
.info-span{
    display:inline-block;
    padding:0px 8px;
    color:#000;
    width:25%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.info-span-red{
    padding:0px 8px;
    color:#f00;
}
</style>
<style lang='scss' scoped>
.nav{
  width: 100%;
  padding: 20px 0px;
  .nav-title{
    width: 100%;
    font-size: 28px;
    font-weight:100;
    text-align: center;
    display: block;
  }
}
.nav-span{
    padding:10px 0;
}

.noList{
  text-align: center;
  margin-top: 50%;
  font-size: 26px;
  color: #ccc;
}
.van-dialog{
  width: 70%;
  height: 15%;
  .van-dialog__content{
    height: 65%;
    padding-top: 5%;
    text-align: center;
    .van-dialog__message{
      text-align: center;
      font-size: 26px;
    }
  }
  .van-dialog__footer--buttons{
    height: 35%;
    .van-button{
      width: 50%;
      height: 100%;
      .van-button__text{
        font-size: 26px;
      }
    }
  }
}
.menu{
    margin-top:0.2rem
}
</style>
